export default __webpack_public_path__ + "static/media/gift.fd530e20.svg";